import React from "react";
import OtpInput from "react-otp-input";
import styles from "./OtpCodeInput.module.scss";

export const OtpCodeInput = ({
  value,
  onValueChange,
  numInputs = 6,
  containerClassName = "",
}) => {
  return (
    <div className={`${styles["otp-input"]} ${containerClassName}`}>
      <OtpInput
        value={value}
        onChange={onValueChange}
        numInputs={numInputs}
        renderSeparator={<span> </span>}
        shouldAutoFocus
        renderInput={(props) => <input {...props} className={`input-style`} />}
      />
    </div>
  );
};
